import axios from '@/plugins/axios.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('user');

export default {
    state: {
        ...EdverumTable.search.state,
        assignableRoles: [],
        createdUsers: [],
    },

    getters: {
        ...EdverumTable.search.getters,
    },

    actions: {
        async fetchAssignableRoles(context) {
            const { data } = await axios.get('/api/assignable-roles?model=user');
            context.commit('SET_ASSIGNABLE_ROLES', data.data);
        },

        addCreatedUser({ commit }, user) {
            commit('ADD_CREATED_USER', user);
        },

        reset: collectionHelpers.actions.reset('Users'),
    },

    mutations: {
        ...EdverumTable.search.mutations,

        SET_ASSIGNABLE_ROLES(state, roles) {
            state.assignableRoles = roles;
        },

        ADD_CREATED_USER(state, user) {
            state.createdUsers.push(user);
        },
    },
};
